import { lazy } from 'react';

const Paragraph = lazy(() => import('./Paragraph'));

export { Paragraph };
